import { render, staticRenderFns } from "./EnRuikaChart.vue?vue&type=template&id=05aa36c1&scoped=true"
import script from "./EnRuikaChart.vue?vue&type=script&lang=ts"
export * from "./EnRuikaChart.vue?vue&type=script&lang=ts"
import style0 from "./EnRuikaChart.vue?vue&type=style&index=0&id=05aa36c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa36c1",
  null
  
)

export default component.exports